var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('views',{staticClass:"loading"},[_c('van-loading',{attrs:{"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }